import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';
import { ESTATUS_AUTORIZADO } from 'utils/constants';

export const baseURI = 'catalogos/estructura-jerarquica';

/**
 * GET all Estructuras Jerarquicas
 * @returns {Promise<object[]>}
 */
export const getAllEstructurasJerarquicas = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET EstructuraJerarquica by ID
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getEstructuraJerarquicaByID = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST EstructuraJerarquica
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const createEstructuraJerarquica = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH EstructuraJerarquica
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const updateEstructuraJerarquica = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE EstructuraJerarquica
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteEstructuraJerarquica = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * AUTORIZAR TipoDeSeguridadSocial
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const autorizarEstructuraJerarquica = async (id) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, { estados_globales: ESTATUS_AUTORIZADO });
    onSuccess(response, 'Autorizado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * GET Clone Estructura
 * @param {int} id
 * @param {int} num_copias
 * @returns {Promise<object[]>}
 */
export const cloneEstructuraJerarquica = async (id) => {
  try {
    const response = await API.get(`/catalogos/duplicar-estructura-jerarquica/${id}`);
    onSuccess(response, 'Duplicado correctamente');
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
    return false;
  }
};
